 <template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
              <!--SID1017 Body Part-->
							<template>
								<el-container class="SID1017__TopicInfoRegisterScreen">
									<div class="SID1017__Container">
										<!-- Breadcrumb section -->
										<el-breadcrumb separator-class="el-icon-arrow-right" class="TopicRegisterLink">
											<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
											<el-breadcrumb-item :to="{ path: '1016' }">トピックス情報一覧</el-breadcrumb-item>
											<el-breadcrumb-item :to="{ path: '' }">トピックス情報登録</el-breadcrumb-item>
										</el-breadcrumb>
										<el-form ref="ruleForm" :rules="rules"  :model="ruleForm" label-width="auto">
											<el-form-item prop="gettopic_id" label="トピックスタイトル">
												<el-input v-model="ruleForm.gettopic_id" value=""></el-input>
											</el-form-item>
											<el-form-item>
												<el-row class="ButtonDiv">
													<!-- // 2023/03/27  #14161  START -->
													<el-button type="primary" plain @click="add('ruleForm')" :disabled="Buttonpressed == 1">登録</el-button>
													<!-- // 2023/03/27  #14161  END -->
													<el-button type="info" plain @click="gotoback">戻る</el-button>
												</el-row>
											</el-form-item>											
										</el-form>
										<el-row>
											<el-col :span="6">
											<div class="userSettingSpan">
												<span>トピックス作成者設定</span>
											</div>
											<div class="TopicInfoRegister">									
												<el-table
													ref="multipleTable"
													:data="getEditUser"
													@selection-change="handleSelectionChangeUser"
													border
													style="width: 100%">
													<el-table-column
													type="selection"
													min-width="auto"
													>
													</el-table-column>
													<el-table-column
													label="ユーザーID"
													min-width="200"	
													property="user_id"							
													>
													</el-table-column>
												</el-table>		
											</div>
											</el-col>
											<el-col :span="8" :offset="1">
											<div class="userSettingSpan">
											<span class="customStar"></span>
												<span><span class="customStar">*</span>対象テーマ設定</span>
											</div>
											<div class="TopicInfoRegister">										
												<el-table class="tableMiddle"
													ref="multipleTable2"
													:data="getEditTheme"
													@selection-change="handleSelectionChangeTheme"
													border
													style="width: 100%">
													<el-table-column
													type="selection"
													width="60"
													>
													</el-table-column>
													<el-table-column
													label="テーマ番号"
													width="100"	
													property="theme_id"											
													>
													</el-table-column>
													<el-table-column
													property="theme_name"
													label="テーマ名"
													min-width="190"													
													>
													</el-table-column>
												</el-table>		
											</div>
											</el-col>
											<el-col :span="8" :offset="1">
											<div class="userSettingSpan">
												<span>ユーザーグループID設定</span>
											</div>
											<div class="TopicInfoRegister">											
												<el-table class="tableBottom"
													ref="multipleTable3"
													:data="getEditUserGroup"
													@selection-change="handleSelectionChangeUserGroup"
													border
													style="width: 100%">
													<el-table-column
													type="selection"
													width="60"
													>
													</el-table-column>
													<el-table-column
													label="ユーザーグループID"
													min-width="200"	
													property="user_group_name"										
													>
													</el-table-column>
													<el-table-column
													label="ユーザ数"
													min-width="auto"
													property="user_count"													
													>
													</el-table-column>
												</el-table>		
											</div>
											</el-col>
										</el-row>									
									</div>
									
								</el-container>
							</template>
              <!--SID1017 Body Part End-->
						</pane>
						
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>

			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from '../../router';
import json from '../../components/config.json';
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
export default {
	name: "1017",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		var confirmLengthTwenty = (rule, value, callback) => {
		var passCheckLength= this.ruleForm.gettopic_id ;
      
            if (passCheckLength.length > 20) {
              callback(new Error('Enter confirm 20 char of password'));
            } 
            else {
              callback();
            }
		};
		
		return {
			// 2023/03/27  #14161  START
			Buttonpressed: 0,
			// 2023/03/27  #14161  END
			form: {
				
			},
			ruleForm: {
				gettopic_id: '',
			
			},
			rules: {
          gettopic_id: [
			{ required: true,type:"string", message: 'トピックスタイトルを入力してください。'},
			/*** Worked by AJ for backlog Id: 1644 */
			// {  required: true,pattern: /^[\u3040-\u30fa\u30fc-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f\uff10-\uff19\uff21-\uff3a\uff41-\uff5a\uff66-\uff9d\uffa0-\uffdf\uffe7-\uffefa-zA-Z0-9]+$/, message: 'トピックスタイトルは記号以外を入力してください。'},
			/***2021/04/20  #10821  START*/
			/***{  required: true,pattern: /^[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f\uff00-\uffefa-zA-Z0-9]+$/, message: 'トピックスタイトルは記号以外を入力してください。'},*/
			{  required: true,pattern: /^[\u2000-\u206f\u2600-\u26ff\u2000-\u206f\u25a0-\u25ff\u3000-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff00-\uffeea-zA-Z0-9]+$/, message: 'トピックスタイトルは記号以外を入力してください。'},
			/***2021/04/20  #10821  END*/
			/*** Worked by AJ for backlog Id: 1644 */
			{  validator: confirmLengthTwenty, message: 'トピックスタイトルは20文字以下を入力してください。'},
            
            
          ],
                  
         
        },
		multipleSelection: [],
		contract_id:''
		
		};
	},
	computed: {
		...mapGetters("situation1017", [
			"getcheck",
			"getname",
			"getEditTheme",
			"getEditUser",
			"getEditUserGroup",
			"getIsEditFlag",
			"getUpdateTheme",
			"getUpdateUser",
			"getUpdateUserGroup",
			"getTopicName",
			"getstatus",
			"getmsgdetail"
		]),
		...mapGetters("situation0001", [
			"getContractId"

		])
	},
	methods: {
		handleSelectionChangeUser(val){
			this.$LogButtonEvent("1017","ChangeUser");
			this.$LogMethodIN("1017","handleSelectionChangeUser");
			this.multipleSelection =  val;
			this.$LogMethodOut("1017","handleSelectionChangeUser");
		},
		handleSelectionChangeTheme(val){
			this.$LogButtonEvent("1017","ChangeTheme");
			this.$LogMethodIN("1017","handleSelectionChangeUserGroup");
			this.multipleSelection2 =  val;
			this.$LogMethodOut("1017","handleSelectionChangeUserGroup");
		},
		handleSelectionChangeUserGroup(val){
			this.$LogButtonEvent("1017","ChangeUserGroup");
			this.$LogMethodIN("1017","handleSelectionChangeUserGroup");
			this.multipleSelection3 =  val;
		this.$LogMethodOut("1017","handleSelectionChangeUserGroup");	
		},
		toggleSelectionUser(rows) {
			if(rows){
				for(let i=0; i<rows.length; i++){
					if(rows[i].checked_status == true){
						this.$refs.multipleTable.toggleRowSelection(rows[i]);
					}
				}
			}else {
				//this.$refs.multipleTable.clearSelection();
			}
		},
		toggleSelectionTheme(rows) {
			if(rows){
				for(let i=0; i<rows.length; i++){
					if(rows[i].checked_status == true){
						this.$refs.multipleTable2.toggleRowSelection(rows[i]);
					}
				}
			}else {
				//this.$refs.multipleTable.clearSelection();
			}
		},
		toggleSelectionUserGroup(rows) {

			if(rows){
				for(let i=0; i<rows.length; i++){
					
					if(rows[i].checked_status == true){
						this.$refs.multipleTable3.toggleRowSelection(rows[i]);
					
					}
					
				}
			}else {
				//this.$refs.multipleTable.clearSelection();
			}
		},
		add(formName) {
			this.$LogButtonEvent("1017","Register");
			this.$LogMethodIN("1017","add");
			this.$refs[formName].validate((valid) => {
				if(this.$refs.multipleTable2.selection.length == 0)
				{
					this.$alert(json["1017_checkbox_not_check_message_title"], json["1017_checkbox_not_check_message"], {
					confirmButtonText: 'OK'
				});
				return false;
				}
			if (valid) {
				// 2023/03/27  #14161  START
                this.Buttonpressed= 1;
                // 2023/03/27  #14161  END
				var user_idArray = [];
				var arrayUserLength = this.$refs.multipleTable.selection.length;
				for (var i = 0; i < arrayUserLength; i++) {
					user_idArray.push((this.$refs.multipleTable.selection[i].user_id));
				}
				var theme_idArray = [];
				var arrayThemeLength = this.$refs.multipleTable2.selection.length;
				for (var j = 0; j < arrayThemeLength; j++) {
					theme_idArray.push((this.$refs.multipleTable2.selection[j].theme_id));
				}
				var usergroup_idArray = [];
				var arrayUserGroupLength = this.$refs.multipleTable3.selection.length;
				for (var k = 0; k < arrayUserGroupLength; k++) {
					usergroup_idArray.push((this.$refs.multipleTable3.selection[k].user_group_id));
				}
				var formCredentials = {};
				if(this.$route.params.Details == undefined){
					formCredentials = {
						contract_id: this.contract_id,
						topics_name:this.ruleForm.gettopic_id,
						user_id: user_idArray,
						theme_id: theme_idArray,
						user_group_id: usergroup_idArray
					};

					this.$store.dispatch('communication1017/passFormDetails', formCredentials)
					.then(() => {
						//After the Ajax call finished check if status is error for showing alert
						var status = this.getstatus;
						var msgdetail = this.getmsgdetail;
						if(status == "0")
						{
							// 2023/03/27  #14161  START
							this.Buttonpressed= 0;
							// 2023/03/27  #14161  END
							router.push({ name: "1016"})
							this.$alert(msgdetail, json["1017_register_success_title"], {	confirmButtonText: 'OK'})
						}
						else if(status == "1")
						{
							// 2023/03/27  #14161  START
							this.Buttonpressed= 0;
							// 2023/03/27  #14161  END
							router.push({name:"1016"});
							this.$alert(msgdetail, json["1017_register_failed_title"] , {	confirmButtonText: 'OK'})							
						}
					})
					.catch((error) => {
						console.log(error);
						// 2023/03/27  #14161  START
						this.Buttonpressed= 0;
						// 2023/03/27  #14161  END
						this.$alert(this.getmsgdetail, json["1017_register_failed_title"], {	confirmButtonText: 'OK'	});
					});
				}else{
					formCredentials = {
						contract_id: this.contract_id,
						topics_id: this.$route.params.Details.topics_id,
						topics_name:this.ruleForm.gettopic_id,
						user_id: user_idArray,
						theme_id: theme_idArray,
						user_group_id: usergroup_idArray
					};

					this.$store.dispatch('communication1017/passFormDetails', formCredentials)	.then(() => {
						//After the Ajax call finished check if status is error for showing alert
						var status = this.getstatus;
						var msgdetail = this.getmsgdetail;
						if(status == "0")
						{
							// 2023/03/27  #14161  START
							this.Buttonpressed= 0;
							// 2023/03/27  #14161  END
							router.push({name:"1016"});
							this.$alert(msgdetail, json["1017_update_success_title"], {	confirmButtonText: 'OK'})	
						}
						else if(status == "1")
						{
							// 2023/03/27  #14161  START
							this.Buttonpressed= 0;
							// 2023/03/27  #14161  END
							router.push({name:"1016"});
							this.$alert(msgdetail, json["1017_Update_failed_title"] , {	confirmButtonText: 'OK'})
						}
					})
					.catch((error) => {
						console.log(error);
						// 2023/03/27  #14161  START
						this.Buttonpressed= 0;
						// 2023/03/27  #14161  END
						this.$alert(this.getmsgdetail, json["1017_Update_failed_title"], {	confirmButtonText: 'OK'	});
					});
				}
			} else {
				return false;
			}
			});
			//   this.text ="メールアドレスが登録されました。";
            this.$LogMethodOut("1017","add");
      },
		gotoback(){
			this.$LogButtonEvent("1017","Return");
			this.$LogMethodIN("1017","gotoback");
			router.push({name:"1016"});
			this.$LogMethodOut("1017","gotoback");
		}
	},

	mounted(){
		this.contract_id = this.getContractId
		//Get table articles during page load
	
	if(this.$route.params.Details == undefined || this.$route.params.Details == ""){
		this.$store.dispatch('communication1017/getTableData');
		
	}
	else{
		
		this.ruleForm.gettopic_id = this.$route.params.Details.topics_name;
		
		this.$nextTick(function(){
			this.toggleSelectionUser(this.getEditUser);
		});

		this.$nextTick(function(){
			this.toggleSelectionTheme(this.getEditTheme);
		});

		this.$nextTick(function(){
			this.toggleSelectionUserGroup(this.getEditUserGroup);
		})
	}
	},
	beforeCreate(){
	//For the screen Title
     document.title = "トピックス情報一覧画面";
		
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1017.css";
</style>